import { render } from "./selector-title.vue?vue&type=template&id=0601a640&scoped=true&ts=true"
import script from "./selector-title.vue?vue&type=script&lang=ts"
export * from "./selector-title.vue?vue&type=script&lang=ts"

import "./selector-title.vue?vue&type=style&index=0&id=0601a640&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0601a640"]])

export default __exports__